import { req } from 'vuelidate/lib/validators/common'
import { withParams } from 'vuelidate'
import { CPF } from 'cpf_cnpj'
import { CNPJ } from 'cpf_cnpj'

export default withParams({ type: 'isCPForCNPJ' }, value =>
  !req(value) || CNPJ.isValid(value) || CPF.isValid(value))
